import React from 'react';
import Axios from 'axios';
import './Login.css';
import { forgotPassword, ROOT_URL } from '../actions';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


class ForgotPasswordClass extends React.Component {
  state = {
    forgotEmail: '',
    emptyUsernameError: false,
    border: "1px solid #ff00007a",
    imageUrl: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAxMC8yOS8xMiKqq3kAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzVxteM2AAABHklEQVRIib2Vyw6EIAxFW5idr///Qx9sfG3pLEyJ3tAwi5EmBqRo7vHawiEEERHS6x7MTMxMVv6+z3tPMUYSkfTM/R0fEaG2bbMv+Gc4nZzn+dN4HAcREa3r+hi3bcuu68jLskhVIlW073tWaYlQ9+F9IpqmSfq+fwskhdO/AwmUTJXrOuaRQNeRkOd5lq7rXmS5InmERKoER/QMvUAPlZDHcZRhGN4CSeGY+aHMqgcks5RrHv/eeh455x5KrMq2yHQdibDO6ncG/KZWL7M8xDyS1/MIO0NJqdULLS81X6/X6aR0nqBSJcPeZnlZrzN477NKURn2Nus8sjzmEII0TfMiyxUuxphVWjpJkbx0btUnshRihVv70Bv8ItXq6Asoi/ZiCbU6YgAAAABJRU5ErkJggg==)"
  }
  componentDidMount(){
  
  }

  forgotPasswordFunc = (e) => {
    e.preventDefault();
    toast.configure({
      autoClose: 5000,
      draggable: false,
      position: toast.POSITION.BOTTOM_RIGHT
      //etc you get the idea
    });
    const { forgotEmail } = this.state;
    if (this.state.forgotEmail) {
      this.props.forgotPasswordAPI({
        registeredEmail: this.state.forgotEmail,
       // host: host
      
    }).then(res=>{
      if(res.text){
        //console.log(res);
      toast("Mail with password reset instructions sent to your email ID")
    }
  });
   } else {
     //console.log('hiii');
      // if (!forgotEmail) {
        this.setState({ emptyUsernameError: true });
      // }
    }
  }
  render() {

    return (
      <div>
           <nav className=" Filters navbar">
        <div className="imgContainer" style={{ marginLeft: "20px" }}>
        {/* <h3 style= {{marginLeft: '50px',"font-family": 'Fantsy', color: 'rgb(255, 127, 14)' , 'font-size':' xx-large' ,'font-variant': 'proportional-nums','text-decoration': 'underline','textDecorationStyle': "double"}} >Rebate.ai</h3> */}
                       <img height="25" src={process.env.PUBLIC_URL + '/IMARK Logo.png'} alt="img  " />
            
          </div>
        </nav>
        <main class="markLogin" style={{ backgroundImage: this.state.imageUrl }}>
          <form className="form-signin">
            <h3 className="mt-5 h3 mb-3 font-weight-normal desc">Enter your Email ID</h3>
            <label for="inputEmail" className="sr-only">Email address</label>
            <input style={{ border: this.state.emptyUsernameError ? this.state.border : "" }} type="email" id="inputEmail" className="form-control" placeholder="Email address" required="" autofocus="" onChange={(e) => { this.setState({errorMessage:'', forgotEmail: e.target.value, emptyUsernameError: false }) }} />
            
            <div className="row loginRow">
              <div className="col-6">
                <button onClick={(e) => this.forgotPasswordFunc(e)} className="btn btn-md btn-success btn-block" >Forgot Password</button>
              </div>
            </div>


          </form>
        </main>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, {
  forgotPasswordAPI: forgotPassword
})(ForgotPasswordClass);